/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserRoleResponse } from '../../models/user-role-response';

export interface UserRoleControllerGetAll$Params {
  query?: string;
  limit: number;
  skip: number;
  order_by?: string;
  order_direction?: string;
}

export function userRoleControllerGetAll(http: HttpClient, rootUrl: string, params: UserRoleControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, userRoleControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserRoleResponse;
      }>;
    })
  );
}

userRoleControllerGetAll.PATH = '/user-role';
